import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout: React.FC = () => {
  const { isAuthenticated, user, token, isLoading } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    console.log('🏠 Layout - Auth Check:', {
      isLoading,
      isAuthenticated,
      hasUser: !!user,
      hasToken: !!token,
      username: user?.username
    });
    
    // SADECE loading bittikten SONRA redirect yap
    if (!isLoading && !isAuthenticated) {
      console.log('⚠️ Layout - Not authenticated, redirecting to login');
      navigate('/login');
    }
  }, [isLoading, isAuthenticated, user, token, navigate]);

  // Loading state - Auth initialization bekle
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col items-center gap-3">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-lifeshare-500"></div>
        <p className="text-gray-600">Yükleniyor...</p>
      </div>
    </div>;
  }

  // Not authenticated - Redirect edilecek
  if (!isAuthenticated) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-lifeshare-500"></div>
    </div>;
  }

  return (
    <div className="flex h-screen bg-[#f5f5f7]">
      {/* Sidebar */}
      <Sidebar />
      
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <Header />
        
        {/* Page Content */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-[#f5f5f7] p-4 sm:p-6 pt-16 lg:pt-6">
          <div className="animate-fade-in max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
